/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import type { Location } from 'history'

export function isNativeAuth(location: Pick<Location, 'pathname' | 'search'>) {
  return (
    /^\/(?:zumper|padmapper)-account\//.test(location.pathname) &&
    new URLSearchParams(location.search).has('embed')
  )
}
